export default "__VITE_ASSET__Bimie_P6__"